<div class="tab-content">
    <div class="page-title">
        <span translate>FEATURES_RIGHTS</span>
    </div>
    <ul class="list-group">
    </ul>
</div>